import React, { useState } from "react";
import "./Saleproperty.css";
import Footer from "./Footer";
const Saleproperty = () => {
  const [formData, setFormData] = useState({
    type: "",
    city: "",
    district: "",
    planNumber: "",
    plotNumber: "",
    direction: "",
    area: "",
    age: "",
    income: "",
    description: "",
    price: "",
    phone: "",
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };
const handleSubmit = async (e) => {
    e.preventDefault();
  
    const formDataToSend = {
      access_key: "0710c64b-9436-4dbb-9e52-6d4a5137a6af", 
      subject: "طلب بيع عقار جديد 🏡",
      from_name: formData.phone, 
      type: formData.type,
      city: formData.city,
      district: formData.district,
      planNumber: formData.planNumber,
      plotNumber: formData.plotNumber,
      direction: formData.direction,
      area: formData.area,
      age: formData.age,
      income: formData.income,
      description: formData.description,
      price: formData.price,
      phone: formData.phone,
    };
  
    try {
      const response = await fetch('https://api.web3forms.com/submit', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formDataToSend),
      });
  
      const result = await response.json();
  
      if (result.success) {
        console.log("Success:", result);
        alert("✅ تم إرسال النموذج بنجاح!");
      } else {
        console.error("Error:", result);
        alert("❌ فشل إرسال النموذج. حاول مرة أخرى.");
      }
    } catch (error) {
      console.error("Error:", error);
      alert("❌ حدث خطأ أثناء الإرسال. حاول لاحقًا.");
    }
  };
  

  return (
    <>
    <div className="form-container">
      <h2>هل لديك عقار للإيجار أو الشراء أو الاستثمار؟🏡</h2>
      <p>إذا كانت الإجابة نعم؟! ✋ فاكتب التفاصيل التالية:</p>
      <form onSubmit={handleSubmit}>
        <label>نوع العقار 🏠</label>
        <input type="text" name="type" onChange={handleChange} required />

        <label>المدينة 🏙️</label>
        <input type="text" name="city" onChange={handleChange} required />

        <label>الحي 📍</label>
        <input type="text" name="district" onChange={handleChange} required />

        <label>رقم الفيروس 🗺️</label>
        <input type="text" name="planNumber" onChange={handleChange} required />

        <label>رقم القطعة 🔢</label>
        <input type="text" name="plotNumber" onChange={handleChange} required />

        <label>الواجهة العقارية 🧭</label>
        <select name="direction" onChange={handleChange} required>
          <option value="">اختر الاتجاه</option>
          <option value="شمالية">شمالية</option>
          <option value="جنوبية">جنوبية</option>
          <option value="شرقية">شرقية</option>
          <option value="غربية">غربية</option>
        </select>

        <label>المساحة 📐 (م²)</label>
        <input type="number" name="area" onChange={handleChange} required />

        <label>عمر العقار ⏳ (بالسنوات)</label>
        <input type="number" name="age" onChange={handleChange} required />

        <label>دخل العقار 💸 (سنويًا)</label>
        <input type="number" name="income" onChange={handleChange} required />

        <label>مواصفات العقار ✨</label>
        <textarea name="description" onChange={handleChange} required />

        <label>السعر ﷼💰</label>
        <input type="number" name="price" onChange={handleChange} required />

        <label>رقم الجوال ☎️</label>
        <input type="tel" name="phone" onChange={handleChange} required />

        <button type="submit">إرسال النموذج</button>
      </form>
      </div>
      <Footer/>
    </>
  );
};

export default Saleproperty;
